export default "<router-outlet></router-outlet>\n<aff-notification></aff-notification>\n"